import React from 'react';
import { Box, CircularProgress, Modal } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { styles } from './styles';

const LoadingModal = () => {
  const theme = useTheme();
  const classes = styles(theme);

  return (
    <Modal open sx={classes.modal}>
      <div aria-live="polite" aria-busy="true">
        <Box
          component="span"
          sx={classes.screenReaderText}
          id="loading-modal-title"
        >
          Loading
          {' '}
          <span className="sr-only">page content</span>
        </Box>
        <Box
          sx={{
            ...classes.box,
            backgroundColor: 'transparent',
          }}
        >
          <CircularProgress
            size={75}
            color="inherit"
            sx={{ color: "#ca4632" }}
          />
        </Box>
      </div>
    </Modal>
  );
};

export default LoadingModal;
